import * as React from "react"
import * as ReactDOM from "react-dom"
import * as Immutable from 'immutable'
import { default as Select, ReactSelectProps } from 'react-select';
import * as moment from 'moment';
import 'whatwg-fetch';

import { StartEnd, PrefixProps } from '../utils/period_picker/PeriodPicker'
import RoomPeriodPicker from '../utils/period_picker/RoomPeriodPicker'

import BnbRoomAndPeriodPickerUtil from '../utils/period_picker/BnbRoomAndPeriodPicker'

import * as RoomEventEmitter from '../utils/period_picker/RoomEventEmitter'

import { Room } from '../types/types'
import { FocusedInputShape } from 'react-dates';

type RoomPickerProps = StartEnd & PrefixProps & {
  rooms: Room[],
  source: string
  initialRoom: number | null
  numberOfMonths?: number
}
type RoomPickerState = { room: number, focusedInput: FocusedInputShape } & StartEnd

export default class BnbRoomAndPeriodPicker extends React.Component<RoomPickerProps, RoomPickerState> {
  subscriptionToken: string
  constructor(props, context) {
    super(props, context)
    this.state = {
      room: this.props.initialRoom,
      startDate: this.props.startDate !== null ? moment(this.props.startDate, "DD-MM-YYYY") : null,
      endDate:   this.props.endDate   !== null ? moment(this.props.endDate,   "DD-MM-YYYY") : null,
      focusedInput: null,
    }
  }

  componentWillMount() {
    this.subscriptionToken = RoomEventEmitter.subscribe((payload: RoomEventEmitter.EventPayload) => {
      if (payload.room_id != this.state.room) {
        this.setState({ room: payload.room_id })
      }
    })
  }

  componentWillUnmount() {
    RoomEventEmitter.unsubscribe(this.subscriptionToken)
  }

  selectRoom(value) {
    this.setState({...this.state, room: value})
  }

  onDatesChange(range: StartEnd) {
    this.setState({ ...range  })
  }

  render() {
    return (
      <BnbRoomAndPeriodPickerUtil
        onRoomChange={(value) => this.selectRoom(value)}
        startDate={this.state.startDate}
        endDate={this.state.endDate}
        rooms={this.props.rooms}
        room={this.state.room}
        source={this.props.source}
        prefix={this.props.prefix}
        onDatesChange={(range: StartEnd) => this.onDatesChange(range)}
        focusedInput={this.state.focusedInput}
        onFocusChange={(fi) => this.setState({focusedInput: fi})}
        numberOfMonths={this.props.numberOfMonths}
        close={() => null}
      />
    )
  }
}